import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";
import _classCallCheck from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/createClass";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable */
//============事件统计==================
import axios from 'axios';
import router from '@/router';
var API = process.env.VUE_APP_STATIS; // 获取xpath

var readXPath = function readXPath(element) {
  if (element.id !== "") {
    // 判断id属性，如果这个元素有id，则显 示//*[@id="xPath"]  形式内容
    // eslint-disable-next-line no-useless-escape
    return '//*[@id=\"' + element.id + '\"]';
  } // 这里需要需要主要字符串转译问题，可参考js 动态生成html时字符串和变量转译（注意引号的作用）


  if (element === document.body) {
    // 递归到body处，结束递归
    return '/html/' + element.tagName.toLowerCase();
  }

  var ix = 1; // 在nodelist中的位置，且每次点击初始化

  var siblings = element.parentNode.childNodes; // 同级的子元素

  for (var i = 0, l = siblings.length; i < l; i++) {
    var sibling = siblings[i]; // 如果这个元素是siblings数组中的元素，则执行递归操作

    if (sibling === element) {
      // console.log(element.parentNode)
      // console.log(element.tagName.toLowerCase())
      return readXPath(element.parentNode) + '/' + element.tagName.toLowerCase() + '[' + ix + ']'; // 如果不符合，判断是否是element元素，并且是否是相同元素，如果是相同的就开始累加
    } else if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
      ix++;
    }
  }
}; // 参数混淆


var confuse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(param) {
    var str, key, key2, innner;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            str = "";

            for (key in param) {
              if (param[key].constructor === Object) {
                str += key + ':';

                for (key2 in param[key]) {
                  innner = param[key];
                  str += key2 + '=' + innner[key2] + '|';
                }

                str = str.slice(0, str.length - 1);
                str += '&';
              } else {
                str += key + '=' + param[key] + '&';
              }
            }

            str = str.slice(0, str.length - 1); // console.log(str)

            return _context.abrupt("return", str);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function confuse(_x) {
    return _ref.apply(this, arguments);
  };
}();

var EventStatis = /*#__PURE__*/function () {
  function EventStatis() {
    _classCallCheck(this, EventStatis);
  }

  _createClass(EventStatis, [{
    key: "getSystemMsg",
    value: // 获取系统信息
    function () {
      var _getSystemMsg = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, aid, v, uid, did, os, b, osv, r, w, wv, match, str, first, first2, osTest, osfirst, oslast, last, last2, wTest, wIndex, systemInfo, _systemInfo, system, systemIndex, u, d, eventStatisParam, response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = {
                  //后面通过配置文件
                  aid: "zzh",
                  //这个是小程序appid,web需要和焱南约定
                  v: "1.0.0"
                };
                aid = res.aid, v = res.v;
                uid = window.GLOBAL_CONFIG ? window.GLOBAL_CONFIG.projectId : "";
                did = "";
                os = "";
                b = "";
                osv = "";
                r = "";
                w = "";
                wv = "";
                match = "pc"; //自己模拟pc、uniapp、wx

                if (match === 'pc') {
                  //pc
                  str = navigator.userAgent.toLowerCase();
                  console.log(str);
                  first = str.indexOf('(');
                  first2 = str.indexOf(';');
                  osTest = str.substring(first + 1, first2);
                  osfirst = osTest.indexOf(" ");
                  os = osTest.substring(0, osfirst);
                  oslast = osTest.lastIndexOf(" ");
                  osv = osTest.substring(oslast + 1, osTest.length);
                  last = str.lastIndexOf(')');
                  last2 = str.lastIndexOf(' ');
                  wTest = str.substring(last + 2, last2);
                  wIndex = wTest.indexOf("/");
                  w = wTest.substring(0, wIndex);
                  wv = wTest.substring(wIndex + 1, wTest.length);
                  r = window.screen.width + "×" + window.screen.height;
                } else if (match === 'uniapp') {
                  //uniapp
                  systemInfo = uni.getSystemInfo();
                  did = systemInfo.deviceId;
                  os = systemInfo.osName;
                  osv = systemInfo.osVersion;
                  r = systemInfo.screenWidth + "x" + systemInfo.screenHeight;
                  b = systemInfo.deviceBrand;
                } else if (math === 'wx') {
                  _systemInfo = wx.getSystemInfo();
                  did = _systemInfo.deviceId || ""; //=======================

                  system = _systemInfo.system;
                  systemIndex = system.indexOf(' ');
                  os = system.substring(0, systemIndex);
                  osv = system.substring(systemIndex + 1, system.length);
                  r = _systemInfo.screenWidth + "x" + _systemInfo.screenHeight;
                  b = _systemInfo.brand;
                }

                u = {
                  aid: aid,
                  // appId
                  uid: uid,
                  // 用户id
                  did: did // 移动端设备id

                };
                d = {
                  v: v,
                  // 客户端版本
                  os: os,
                  // 操作系统
                  osv: osv,
                  // 操作系统版本
                  r: r,
                  // 分辨率
                  wv: wv,
                  // 浏览器版本
                  w: w,
                  // 浏览器
                  b: b //手机品牌

                };
                eventStatisParam = {
                  d: d,
                  u: u
                };
                localStorage.setItem('eventStatisParam', JSON.stringify(eventStatisParam));
                _context2.prev = 16;
                _context2.next = 19;
                return axios.get(API + "config/".concat(aid, ".json?r=").concat(new Date().getTime()));

              case 19:
                response = _context2.sent;

                if (response.data.length) {
                  localStorage.setItem('eventStatisClickList', JSON.stringify(response.data));
                }

                _context2.next = 26;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2["catch"](16);
                console.log(_context2.t0);

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[16, 23]]);
      }));

      function getSystemMsg() {
        return _getSystemMsg.apply(this, arguments);
      }

      return getSystemMsg;
    }() // 捕获所有的点击事件

  }, {
    key: "allClick",
    value: function () {
      var _allClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var eventStatisClickList, autoEventStatis, that, iframes, doms, i, dom;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                eventStatisClickList = JSON.parse(localStorage.getItem('eventStatisClickList'));

                if (!(!eventStatisClickList || eventStatisClickList.length === 0)) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                autoEventStatis = eventStatisClickList.filter(function (item) {
                  return item.eventType === "auto";
                });
                that = this;
                iframes = document.getElementById("iframe1");

                if (!iframes) {
                  _context5.next = 9;
                  break;
                }

                iframes.contentWindow.addEventListener("click", /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
                    var xPath, j, ele, f12Xpath;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return readXPath(e.target);

                          case 2:
                            xPath = _context3.sent;

                            for (j = 0; j < autoEventStatis.length; j++) {
                              ele = autoEventStatis[j]; // f12和js获取到的xPath都去除掉[1]

                              f12Xpath = ele.xpath.replace(/\[1\]/g, '');
                              f12Xpath = f12Xpath.replace(/\'/g, '"');
                              xPath = xPath.replace(/\[1\]/g, '');
                              console.log(f12Xpath);
                              console.log("========================");
                              console.log(xPath, "自动");

                              if (f12Xpath === xPath) {
                                that.eventPush({
                                  eid: ele.eventId
                                });
                              }
                            }

                          case 4:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                return _context5.abrupt("return");

              case 9:
                doms = document.getElementsByTagName('*');

                for (i = 0; i < doms.length; i++) {
                  dom = doms[i];
                  dom.addEventListener('click', /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
                      var xPath, j, ele, f12Xpath;
                      return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.next = 2;
                              return readXPath(this);

                            case 2:
                              xPath = _context4.sent;

                              for (j = 0; j < autoEventStatis.length; j++) {
                                ele = autoEventStatis[j]; // f12和js获取到的xPath都去除掉[1]

                                f12Xpath = ele.xpath.replace(/\[1\]/g, '');
                                xPath = xPath.replace(/\[1\]/g, ''); // console.log(f12Xpath)
                                // console.log("========================");
                                // console.log(xPath,"自动")

                                if (f12Xpath === xPath) {
                                  that.eventPush({
                                    eid: ele.eventId
                                  });
                                }
                              }

                            case 4:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4, this);
                    }));

                    return function (_x3) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                }

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function allClick() {
        return _allClick.apply(this, arguments);
      }

      return allClick;
    }() //事件统计-手动

  }, {
    key: "manualStatis",
    value: function manualStatis(params) {
      var eventStatisClickList = JSON.parse(localStorage.getItem('eventStatisClickList'));

      if (!eventStatisClickList || eventStatisClickList.length === 0) {
        return;
      }

      var eid = params.eid;
      var eventItem = null; // 写好了事件id

      if (eid) {
        eventItem = eventStatisClickList.find(function (item) {
          return item.eventId === eid;
        });
      } else {
        // 不知道事件id，但是知道业务参数，多用于循环出来的元素事件
        var type = params.type;
        eventItem = eventStatisClickList.find(function (item) {
          if (!item.params) return false;
          var statisParams = item.params;
          if (!statisParams.type) return false;else {
            return statisParams.type === type;
          }
        });
      }

      if (eventItem) {
        var statisParams = eventItem.params || {};
        var custonParams = params.p || {};
        this.eventPush({
          eid: eventItem.eventId,
          p: _objectSpread(_objectSpread({}, statisParams), custonParams)
        });
      }
    } //事件统计提交

  }, {
    key: "eventPush",
    value: function () {
      var _eventPush = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(params) {
        var param, r, eid, confuseParam, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                param = JSON.parse(localStorage.getItem('eventStatisParam')) || {};
                param.ts = new Date().getTime(); //时间戳

                r = router.currentRoute.path;
                eid = params.eid || "";
                param.c = {
                  r: r,
                  //路由地址
                  eid: eid //事件id

                };
                param.p = params.p || {};
                _context6.next = 8;
                return confuse(param);

              case 8:
                confuseParam = _context6.sent;
                _context6.prev = 9;
                _context6.next = 12;
                return axios.post(API + "api/log/put", confuseParam);

              case 12:
                res = _context6.sent;
                _context6.next = 18;
                break;

              case 15:
                _context6.prev = 15;
                _context6.t0 = _context6["catch"](9);
                console.log(_context6.t0);

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[9, 15]]);
      }));

      function eventPush(_x4) {
        return _eventPush.apply(this, arguments);
      }

      return eventPush;
    }()
  }]);

  return EventStatis;
}();

export default {
  EventStatis: EventStatis
};